import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getChartEntry } from '../../config/chartRegistry';
import type { ChartType } from '../../types';

const BASE_URL = 'https://www.chart2video.com';

export const ChartSEOMeta: React.FC<{ chartType: ChartType }> = ({ chartType }) => {
  const entry = getChartEntry(chartType);
  if (!entry?.seo) return null;
  const { seo } = entry;
  const url = `${BASE_URL}/${seo.slug}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.metaDesc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.metaDesc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.metaDesc} />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": seo.h1,
        "url": url,
        "applicationCategory": "BusinessApplication",
        "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
        "description": seo.metaDesc,
      })}</script>
    </Helmet>
  );
};

export const ChartSEOTextBlock: React.FC<{ chartType: ChartType }> = ({ chartType }) => {
  const entry = getChartEntry(chartType);
  if (!entry?.seo) return null;
  const { seo } = entry;

  const words = seo.h1.split(' ');
  const accent = words.pop();
  const rest = words.join(' ');

  return (
    <div className="c2v-seo-strip">
      <div className="c2v-seo-strip__inner">
        <h1 className="c2v-seo-strip__heading">
          {rest} <span>{accent}</span>
        </h1>
        <p className="c2v-seo-strip__body">{seo.bodyText}</p>

        {seo.features && seo.features.length > 0 && (
          <div className="c2v-seo-strip__features">
            {seo.features.map(f => (
              <div key={f.title} className="c2v-seo-strip__feature">
                <div className="c2v-seo-strip__feature-icon">{f.icon}</div>
                <div className="c2v-seo-strip__feature-text">
                  <strong>{f.title}</strong>
                  <span>{f.desc}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
